import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SoundAssetKeys from '../SoundAssetKeys';

export default class ToggleButton extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y, unselectedFrame)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this._isSelected = false;

        this._frame = ABCyaPhaser.Images.addImage(0, 0, unselectedFrame, this);
        this._selectedBox = this.scene.add.graphics({ lineStyle: { color: 0x000000, width: 4 } }).setVisible(false);
        let rectangle = new Phaser.Geom.Rectangle(-this._frame.width / 2, -this._frame.height / 2, this._frame.width, this._frame.height);
        this._selectedBox.strokeRoundedRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height, 10);
        this.add(this._selectedBox);

        ABCyaPhaser.Container.setContainerInteractive(this);

        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this.scene);
            this._isSelected = !this._isSelected;
            this._selectedBox.setVisible(this._isSelected);
            if (this._isSelected)
            {
                this.emit(TOGGLE_SELECTED, this);
            }
        });
    }

    get isSelected()
    {
        return this._isSelected;
    }

    select()
    {
        this._isSelected = true;
        this._selectedBox.setVisible(this._isSelected);
    }

    deselect()
    {
        this._isSelected = false;
        this._selectedBox.setVisible(this._isSelected);
    }
}

export const TOGGLE_SELECTED = "toggleselected";